import i18n from '@/lang/index'
const { t } = i18n.global
export const errorCode: any = {
  '401': t('system.rzfail'),
  '403': t('system.curnopermission'),
  '404': t('system.resourceNotExist'),
  default: t('system.unkonwnError')
};
export default errorCode;
